import React from 'react';
import SupportedCurrencyPairsHeroSection from "../components/supportedCurrencyPairs/SupportedCurrencyPairsHeroSection";
import SupportedCurrencyPairs from '../components/supportedCurrencyPairs/SupportedCurrencyPairs';
import CtaArea from "../components/CtaArea";

const SupportedPairs = () => {
  return (
    <>
      <SupportedCurrencyPairsHeroSection/>
      {/* <AboutUsBanner/> */}
      <SupportedCurrencyPairs />
      <CtaArea/>
    </>
  );
};

export default SupportedPairs; 